export default __webpack_public_path__ + "static/media/he3d.2c5a11cf.png";